import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiPhone, FiStar, FiMoreVertical, FiCoffee, FiCamera, FiShield, FiZap, FiMusic } from 'react-icons/fi';
import { VENDOR_DATA } from '../data/mockData';

const getVendorIcon = (type) => {
  if (type.includes('Food')) return FiCoffee;
  if (type.includes('A/V')) return FiZap;
  if (type.includes('Decor')) return FiMusic;
  if (type.includes('Security')) return FiShield;
  return FiCamera;
};

export default function VendorBoard() {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="h-full flex flex-col pb-24 pr-2 no-scrollbar overflow-y-auto">
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-3xl font-black text-white italic">VENDOR <span className="text-[#9D4EDD]">NETWORK</span></h1>
          <p className="text-[#94A3B8] text-sm mt-1">Verified service nodes in active sectors</p>
        </div>
        <button className="bg-white/5 hover:bg-white/10 text-white border border-white/10 px-6 py-2 rounded-xl text-xs font-black uppercase tracking-widest transition-all">
          Directory
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {VENDOR_DATA.map((vendor, index) => {
          const VendorIcon = getVendorIcon(vendor.type);
          return (
            <motion.div 
              initial={{ opacity: 0, y: 20 }} 
              animate={{ opacity: 1, y: 0 }} 
              transition={{ delay: index * 0.1 }} 
              key={vendor.id} 
              className="glass-panel p-6 border-white/5 hover:border-[#9D4EDD]/40 transition-all group relative overflow-hidden flex flex-col h-full"
            >
              <div className="absolute -right-6 -top-6 w-24 h-24 bg-[#9D4EDD]/5 rounded-full blur-xl group-hover:bg-[#9D4EDD]/10 transition-colors"></div>
              
              <div className="flex justify-between items-start mb-6 relative z-10">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-[#1A1A24] to-[#0A0A0F] border border-white/10 flex items-center justify-center text-[#9D4EDD] group-hover:text-[#E5C158] transition-colors">
                    <SafeIcon icon={VendorIcon} className="text-xl" />
                  </div>
                  <div>
                    <span className="text-[10px] uppercase tracking-[0.2em] text-[#E5C158] font-black">{vendor.type}</span>
                    <h3 className="text-lg font-bold text-white leading-tight">{vendor.name}</h3>
                  </div>
                </div>
                <button className="text-[#94A3B8] hover:text-white p-1">
                  <SafeIcon icon={FiMoreVertical} />
                </button>
              </div>

              <div className="space-y-4 mb-8 flex-1 relative z-10">
                <div className="flex items-center justify-between p-3 rounded-xl bg-black/30 border border-white/5">
                  <span className="text-[10px] uppercase font-bold text-[#94A3B8]">Status</span>
                  <span className={`px-2 py-1 rounded-lg text-[10px] font-black uppercase tracking-widest ${
                    vendor.status === 'Operational' ? 'bg-green-500/10 text-green-400' : 'bg-yellow-500/10 text-yellow-400'
                  }`}>
                    {vendor.status}
                  </span>
                </div>
                <div className="flex items-center justify-between p-3 rounded-xl bg-black/30 border border-white/5">
                  <span className="text-[10px] uppercase font-bold text-[#94A3B8]">Node Trust</span>
                  <div className="flex items-center gap-1 text-[#E5C158]">
                    <span className="font-mono">{vendor.rating}</span>
                    <SafeIcon icon={FiStar} className="fill-current text-[10px]" />
                  </div>
                </div>
              </div>

              <div className="flex gap-3 relative z-10">
                <button className="flex-1 bg-white/5 hover:bg-white/10 text-white rounded-xl py-3 text-xs font-black uppercase tracking-widest transition-colors flex items-center justify-center gap-2 border border-white/5">
                  <SafeIcon icon={FiPhone} /> Comms
                </button>
                <button className="flex-1 bg-[#9D4EDD]/10 hover:bg-[#9D4EDD]/20 text-[#9D4EDD] border border-[#9D4EDD]/30 rounded-xl py-3 text-xs font-black uppercase tracking-widest transition-colors">
                  Profile
                </button>
              </div>
            </motion.div>
          );
        })}

        <motion.div 
          className="glass-panel border-dashed border-white/10 p-8 flex flex-col items-center justify-center text-center cursor-pointer hover:border-[#9D4EDD]/40 hover:bg-white/5 transition-all min-h-[280px]"
        >
          <div className="w-16 h-16 rounded-full bg-black/40 flex items-center justify-center mb-4 border border-white/5 text-[#94A3B8] group">
            <span className="text-3xl font-light group-hover:scale-125 transition-transform">+</span>
          </div>
          <h3 className="text-white font-bold text-lg">Initialize New Node</h3>
          <p className="text-[#94A3B8] text-sm mt-1 max-w-[180px]">Scan regional directory for verified providers</p>
        </motion.div>
      </div>
      
      <div className="mt-12 text-center">
        <p className="text-[10px] text-[#94A3B8] uppercase tracking-[0.4em] font-light">
          Secured by <span className="text-white font-bold">LingLink</span> Protocol
        </p>
      </div>
    </motion.div>
  );
}